import React, { useState, useEffect, useContext, useRef } from "react";
import Select, { createFilter } from "react-select";
import TextSelect from '../../components/customInputs/select';
import { AuthContext } from "../../context/mslaContext.js";
import { RadioInputs } from "../../style/form/radio";
import { CheckBoxInputs } from "../../style/form/checkbox";
import { ApiService } from "./apiCalls";

import getConfig from "next/config";

// Only holds serverRuntimeConfig and publicRuntimeConfig
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

const formatCurrencyString = (value) => {
  // console.log(value)
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

const cleanFormatCurrency = (value) => {
  if (typeof value != "string") return value;
  // console.log("replaced value",value.replace(/[^0-9\.]/g, ''));

  return value.replace(/[^0-9\.]/g, "");
};

/*
 *   componente que se encarga de mantener estado de html en react. Se usa useState para llamar rerender cuadno se modifica warning.
 *
 *   Si es necesario ir cambiando los classnames usar useState en ves de variables para forzar react a hacer re-render.
 *   (agregar metodos para cambiar estos valores en el objeto que regresa)
 *
 */
let getTooltip = ({ tooltip, labelClass }, fileField = false) => {
  if (!tooltip) return null;
  let tooltipElem = (
    <>
      <div
        className={`${labelClass}__tooltip ${fileField ? "file_unready_tooltip" : ""
          }`}
      >
        <img
          alt="informacion"
          src="/assets/tooltip_off.png"
          className="tooltip_off"
        />
        <img
          alt="informacion"
          src="/assets/tooltip_on.svg"
          className="tooltip_on"
        />
        <span
          className={`${labelClass}__tooltiptext`}
          dangerouslySetInnerHTML={{ __html: `${tooltip.text}` }}
        />
      </div>
      {fileField ? (
        <div className={`${labelClass}__tooltip file_ready_tooltip`}>
          <img
            alt="informacion"
            src="/assets/tooltip_off_ready.png"
            className="tooltip_off"
          />
          <img
            alt="informacion"
            src="/assets/tooltip_on_ready.png"
            className="tooltip_on"
          />
          <span
            className={`${labelClass}__tooltiptext`}
            dangerouslySetInnerHTML={{ __html: `${tooltip.text}` }}
          />
        </div>
      ) : null}
    </>
  );
  return tooltipElem;
};
let getLabelIcon = (icon) => {
  if (!icon) return "";
  return `<img
                src = "${icon.src}"
                alt = "${icon.alt}"
            />`;
};
let InputLabelComponent = ({ label, forId, fileField = false }) => {
  if (!label) return null;
  let tooltip = getTooltip(
    { tooltip: label.tooltip, labelClass: label.class },
    fileField
  );
  let icon = fileField ? "" : label.icon
    ? `<div class = "${label.class}__icon ${fileField ? "file_unready_icon" : ""
    }">${getLabelIcon(label.icon)}</div>`
    : "";
  let readyIcon = fileField ? "" : label.icon_ready
    ? `<div class = "${label.class}__icon file_ready_icon">${getLabelIcon(
      label.icon_ready
    )}</div>`
    : "";

  return (
    <div className={label.class}>
      {tooltip && !label.tooltip.end && !fileField ? tooltip : null}
      <label
        htmlFor={forId}
        dangerouslySetInnerHTML={{
          __html: `${icon} ${readyIcon} <div class="label__text">${label.text}</div>`,
        }}
      />
      {tooltip && label.tooltip.end && !fileField ? tooltip : null}
    </div>
  );
};
const InputLabel = React.memo(InputLabelComponent, (prevProps, nextProps) => {
  return prevProps.label == nextProps.label;
});

const FieldComponentFactory = (props, changeValue, form) => {
  let configModal = form().getFunction("modal");
  const [warning, setwarning] = useState("");
  const [value, setValue] = useState("");
  const auth = useContext(AuthContext);
  const [isActive, setIsActive] = useState(false);
  const [failedUpload, setFailedUpload] = useState(false)
  let endpointResponse = useRef("");
  let rfState = {};
  if (props.reqFields) {
    props.reqFields.map((rf) => {
      rfState[rf] = false;
    });
  }
  const [enabled, setEnabled] = useState(
    typeof props.reqFields === "undefined"
  );
  const valueRef = useRef(null);
  const reqFieldsState = useRef(rfState);
  const [loading, setLoading] = useState(false);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  let constraints = props.requirements;

  let getProps = (props) => {
    let type = props.type;
    let menuClass = props.menuClass ? props.menuClass : '';
    let itemClass = props.itemClass ? props.itemClass : '';
    let outerDivClass =
      typeof props.outerDivClass === "undefined" ? "" : props.outerDivClass;
    let innerDivFieldClass =
      typeof props.innerDivFieldClass === "undefined"
        ? ""
        : props.innerDivFieldClass;
    if (!enabled) innerDivFieldClass += " disabled-field";
    let innerFieldClass =
      typeof props.innerFieldClass === "undefined" ? "" : props.innerFieldClass;
    let innerDivWarClass =
      typeof props.innerDivWarClass === "undefined"
        ? ""
        : props.innerDivWarClass;
    let innerWarningClass =
      typeof props.innerWarningClass === "undefined"
        ? ""
        : props.innerWarningClass;
    let activeClass =
      typeof props.activeClass === "undefined" ? "" : props.activeClass;
    let readyClass =
      typeof props.readyClass === "undefined" ? "" : props.readyClass;
    let selectOptions =
      ["select", "textSelect"].includes(type)
        ? props.options.map((o) =>
          o.label
            ? o
            : {
              label: o,
              value: o,
            }
        )
        : null;
    let radioOptions = type == "radio" ? props.options : null;
    let checkboxOptions = type == "checkbox" ? props.options : null;
    let inputName = typeof props.name === "undefined" ? "" : props.name;
    let id = props.id;
    let label = props.label;
    let paths = typeof props.paths === "undefined" ? null : props.paths;
    let postal =
      typeof props.requirements === "undefined"
        ? false
        : props.requirements.includes("postal");
    let containerDivClass =
      typeof props.containerDivClass === "undefined"
        ? ""
        : props.containerDivClass;
    let fieldIcon =
      typeof props.fieldIcon === "undefined" ? "" : props.fieldIcon;
    let placeholder =
      typeof props.placeholder === "undefined" ? "" : props.placeholder;
    let reqFieldsDisplay =
      typeof props.reqFieldsDisplay === "undefined"
        ? ""
        : props.reqFieldsDisplay;
    let endpoint = typeof props.endpoint === "undefined" ? "" : props.endpoint;
    let listClass = props.listClass ? props.listClass : '';
    let arrowClass = props.arrowClass ? props.arrowClass : '';
    let format = props.format ? props.format : '';
    return {
      format,
      arrowClass,
      listClass,
      itemClass,
      menuClass,
      id,
      type,
      outerDivClass,
      innerDivFieldClass,
      innerFieldClass,
      innerDivWarClass,
      innerWarningClass,
      activeClass,
      readyClass,
      selectOptions,
      radioOptions,
      inputName,
      label,
      paths,
      postal,
      fieldIcon,
      containerDivClass,
      placeholder,
      checkboxOptions,
      reqFieldsDisplay,
      endpoint,
    };
  };
  let fieldProperties = getProps(props);

  let getLimits = (constraints, value) => {
    let trimmedVal = value;

    constraints.some((item) => {
      let limit = 0;
      if (item.includes("<") && item.includes("size")) {
        limit = item.split("<")[1];
        if (trimmedVal.length > limit - 1) {
          trimmedVal = trimmedVal.substring(0, limit - 1);
        }
      }
    });

    return trimmedVal;
  };
  let setParam = (param, body) => {
    switch (param.type) {
      case "object":
        body[param.paramName] = {};
        break;
      default:
        let val = null;
        switch (param.scope) {
          case "globalPoA":
            val = form().getVariable(param.chkpoint)[param.varName];
            break;
          case "global":
            val = form().getVariable(param.varName);
            break;
          case "self":
            val = valueRef.current;
            break;
          case "self-attr":
            val = valueRef.current[param.attrName];
            // console.log("currentval",valueRef.current)
            break;
          case "form":
            val = form().getField(param.fieldName).getValue();
            break;
          case "fixed-value":
            val = param.fixedValue;
            break;
          default:
            break;
        }
        if (param.objectName) {
          body[param.objectName][param.paramName] = val;
        } else {
          body[param.paramName] = val;
        }
        break;
    }
    // console.log(body);
  };
  let callEndpoint = async (endpoint) => {
    let formData = new FormData();
    let url = endpoint.url;
    let bodyVars = {};
    endpoint.params.map((param) => {
      setParam(param, bodyVars);
    });
    Object.keys(bodyVars).map((key) => {
      // console.log(key, bodyVars[key], (typeof bodyVars[key] === 'object' && bodyVars[key] !== null && !(bodyVars[key] instanceof File)))
      let fdValue =
        typeof bodyVars[key] === "object" &&
          bodyVars[key] !== null &&
          !(bodyVars[key] instanceof File)
          ? JSON.stringify(bodyVars[key])
          : bodyVars[key];
      formData.append(key, fdValue);
    });
    let accessToken = await auth.getAccessToken();
    return ApiService().post(url, formData, null, accessToken);
  };
  let handleInput = (event, select = false) => {
    if (props.name === "clave_curp") {
      form().setCurp(event.target.value);
    } else if (props.name === "email") {
      form().setEmail(event.target.value);
    }
    let valueTemp = event.target.value;
    if (!select && event.target.type != "checkbox") {
      valueTemp = getLimits(props.requirements, valueTemp);
      switch (props.format) {
        case "texto":
          valueTemp = valueTemp.replace(/[^a-zA-ZñÑ\sáéíóúÁÉÍÓÚ]/g, "");
          break;
        case "folio_mercantil":
          valueTemp = valueTemp.replace(/[^0-9a-zA-ZñÑáéíóúÁÉÍÓÚ\-\*]/g, "");
          break;
        case "alfanumerico":
          valueTemp = valueTemp.replace(/[^0-9a-zA-ZñÑ\sáéíóúÁÉÍÓÚ]/g, "");
          break;
        case "registro_patronal":
          valueTemp = valueTemp
            ? valueTemp.match(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ]{0,1}\d*]*/g)
              ? valueTemp.match(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ]{0,1}\d*]*/g)[0]
              : ""
            : "";
          break;
        case "dinero":
          valueTemp = getLimits(props.requirements, event.target.value.replaceAll("$","").replaceAll(",",""))
          break;
        default:
          break;
      }
      if (!valueTemp) valueTemp = "";

      if (props.requirements.includes("number") && props.format != "dinero") {
        valueTemp = valueTemp.replace(/[^0-9]/g, "");
      }
      if (props.requirements.includes("number") && props.format == "dinero") {
        valueTemp = valueTemp.replace(/[^0-9\.]/g, "");
        // console.log(valueTemp);
      }
      if (props.requirements.includes("number") && props.format == "dinero" && event.target.value.startsWith("$")) {
        valueTemp = valueTemp.replace(/\.$/g, "");
        // console.log(valueTemp);
      }
      if (
        event.type === "blur" &&
        props.format == "dinero" &&
        !isNaN(valueTemp.replace("$", ""))
      ) {
        if (valueTemp) {
          valueTemp = formatCurrencyString(Number(valueTemp.replace("$", "")));
          // console.log(valueTemp);
        }
      }
    }
    if (event.target.type == "checkbox") {
      let currVal = value;
      let isChecked = event.target.checked;
      let indx = -1;
      if (currVal) {
        if (!isChecked) {
          indx = currVal.indexOf(valueTemp);
          // console.log("indx", indx)
          if (currVal.indexOf(valueTemp) !== -1) {
            currVal.splice(indx, 1);
          }
        } else {
          currVal.push(valueTemp);
        }
      } else {
        if (isChecked) {
          currVal = [];
          currVal.push(valueTemp);
        }
      }
      if (currVal.length == 0) currVal = "";
      // console.log(currVal)
      valueTemp = currVal;
    }
    if (event.nativeEvent.key !== "Tab") {
      // console.log("changgge")
      if (props.format == "dinero" && valueTemp) {
        changeValue(cleanFormatCurrency(valueTemp));
      } else {
        changeValue(valueTemp);
      }
    }

    if (event.nativeEvent.key == "automatic") {
      if (props.format == "dinero" && valueTemp) {
        valueTemp = formatCurrencyString(Number(valueTemp.replace("$", "")));
      }
    }
    // console.log("setValue");
    setValue(valueTemp);
    if (event.target.type == "checkbox") {
      forceUpdate();
    }
  };
  let handleUpdateValue = async (event) => {
    let eventTarget = event.target;
    if (!event.prefilledValue) {
      let prevFields = true;
      let missingFields = [];
      if (props.reqFields) {
        // console.log(form)
        props.reqFields.map((reqField) => {
          let fieldToGet = form().getField(reqField);
          if (!fieldToGet.isReady()) {
            prevFields = false;
            missingFields.push(fieldToGet.getLabel().text);
          }
        });
      }
      if (!prevFields && missingFields) {
        let warningText = "Primero llenar ";
        missingFields.map((fieldMissing, i) => {
          let textToAdd = "";
          // console.log(i)
          switch (i) {
            case missingFields.length - 2:
              // console.log("penultimo")
              textToAdd = fieldMissing + " y ";
              break;
            case 0 || missingFields.length - 1:
              // console.log("igual a 0 o ultimo")
              textToAdd = fieldMissing;
              break;
            default:
              // console.log("defaulti")
              textToAdd = fieldMissing + ", ";
              break;
          }
          warningText += textToAdd;
        });
        if (eventTarget) {
          eventTarget.value = null;
        }
        changeValue({ warning: warningText });
        return;
      }
    }
    switch (props.type) {
      case "select":
      case "textSelect":
        if (event.target) {
          // setValue(event.target.value)
          handleInput(event, true);
        } else {
          setValue(event.value);
          changeValue(event.value);
        }
        break;
      case "file":
        if (event.prefilledValue) {
          setValue({ name: eventTarget.value.fileName });
        } else {
          if (eventTarget.files.length == 0) {
            return;
          }
          if (
            validateFileName(eventTarget.files[0].name) &&
            validateFileFormat(props.format, eventTarget.files[0].type) &&
            validateFileSize(props.fileMaxSize, eventTarget.files[0])
          ) {
            // console.log("pasó las validaciones");
            valueRef.current = eventTarget.files[0];
            // console.log("correct format");
            if (props.endpoint) {
              setLoading(true);
              setwarning("");
              setFailedUpload(false);
              let request = callEndpoint(props.endpoint)
                .then((response) => {
                  setValue(valueRef.current);
                  changeValue(valueRef.current);
                  endpointResponse.current = response;

                  // console.log(response);
                })
                .catch((err) => {
                  // console.log("errore api", err);
                  setFailedUpload(true);
                  // changeValue({
                  //   warning:
                  //     "Ocurrió un error, por favor intentalo una vez más.",
                  // });
                  if (eventTarget) {
                    eventTarget.value = null;
                  }
                })
                .finally(() => {
                  setLoading(false);
                });
            }
          } else {
            let warningText = "";
            if (!validateFileFormat(props.format, eventTarget.files[0].type)) {
              warningText += "El archivo no está en un formato adecuado<br>";
            }
            if (!validateFileName(eventTarget.files[0].name)) {
              warningText += "El nombre del archivo debe tener un máximo de 250 caracteres<br>";
            }
            if (!validateFileSize(props.fileMaxSize, eventTarget.files[0])) {
              warningText += `El archivo supera los ${props.fileMaxSize}mb de tamaño.`;
            }
            changeValue({ warning: warningText });

            // console.log("incorrect format");
          }
        }
        // console.log(event.target.files[0])
        break;
      case "checkbox":
        handleInput(event);
        break;
      default:
        handleInput(event);
        break;
    }
  };
  let clearField = () => {
    // if(fieldProperties.type == "abstract-group"){console.log("absotract");return;}
    let currField = document.getElementById(fieldProperties.id);
    if (currField) currField.value = null;
    valueRef.current = "";
    setValue(valueRef.current);
    changeValue({ warning: "" });
    endpointResponse.current = "";
  };
  let validateFileName = (name) => {
    return name.length < 251;
  }
  let validateFileFormat = (reqFormats, fileType) => {
    if (!reqFormats) return true;
    let correct = false;
    let formats = reqFormats.split(",");
    formats.map((format) => {
      switch (format) {
        case "jpg":
          if (fileType == "image/jpeg") correct = true;
          break;
        case "pdf":
          if (fileType == "application/pdf") correct = true;
          break;
        case "png":
          if (fileType == "image/png") correct = true;
          break;
        default:
          break;
      }
    });
    return correct;
  };
  let validateFileSize = (maxSize, file) => {
    if (maxSize * 1048576 < file.size) {
      console.log("demasiado pesado");
      return false;
    } else {
      return true;
    }
  };
  let addActiveClass = (state = true) => {
    setIsActive(state);
  };
  let getInputHandlers = () => {
    return {
      handleInput,
      handleUpdateValue,
    };
  };
  let getCheckboxField = (
    { handleUpdateValue, handleInput } = getInputHandlers()
  ) => {
    // console.log(fieldProperties, CheckBoxInputs)
    let currVal = value;
    return (
      <div
        key={`${fieldProperties.id}_field`}
        className={fieldProperties.outerDivClass}
        id={`${fieldProperties.id}_field`}
      >
        <InputLabel label={fieldProperties.label} forId={fieldProperties.id} />
        <CheckBoxInputs>
          {fieldProperties.checkboxOptions.map((checkbox, i) => (
            <div
              key={i}
              className={`item ${fieldProperties.innerDivFieldClass}`}
            >
              <label
                className={`item__label ${fieldProperties.innerFieldClass}`}
                htmlFor={`${fieldProperties.id}_${checkbox.id}`}
              >
                <div className="item__checkbox">
                  <input
                    disabled={!enabled}
                    name={fieldProperties.inputName}
                    checked={value ? currVal.includes(checkbox.value) : false}
                    value={checkbox.value}
                    onChange={(e) => {
                      handleUpdateValue(e);
                    }}
                    type="checkbox"
                    id={`${fieldProperties.id}_${checkbox.id}`}
                  />
                  <img
                    className="unchecked"
                    alt="no seleccionado"
                    src="/assets/form/checkbox_unchecked.png"
                  />
                  <img
                    className="checked"
                    alt="seleccionado"
                    src="/assets/form/checkbox_checked.png"
                  />
                </div>
                <span
                  className="item__label__span"
                  dangerouslySetInnerHTML={{ __html: `${checkbox.label}` }}
                />
              </label>
              {getTooltip({ tooltip: checkbox.tooltip, labelClass: "item" })}
            </div>
          ))}
        </CheckBoxInputs>
        <InputWarning
          innerDivWarClass={fieldProperties.innerDivWarClass}
          innerWarningClass={fieldProperties.innerWarningClass}
          warning={warning}
        />
      </div>
    );
  };
  let getRadioField = (
    { handleUpdateValue, handleInput } = getInputHandlers()
  ) => {
    return (
      <div
        key={`${fieldProperties.id}_field`}
        className={fieldProperties.outerDivClass}
        id={`${fieldProperties.id}_field`}
      >
        <InputLabel label={fieldProperties.label} forId={fieldProperties.id} />
        <RadioInputs>
          {fieldProperties.radioOptions.map((radio, i) => (
            <div
              key={i}
              className={`item ${fieldProperties.innerDivFieldClass}`}
            >
              <label
                className={`item__label ${fieldProperties.innerFieldClass}`}
                htmlFor={`${fieldProperties.id}_${radio.id}`}
              >
                <div
                  className={`item__radio ${radio.itemClass ? radio.itemClass : ""
                    }`}
                >
                  <input
                    disabled={!enabled}
                    name={fieldProperties.inputName}
                    value={radio.value}
                    checked={value == radio.value}
                    onChange={(e) => {
                      handleUpdateValue(e);
                    }}
                    type="radio"
                    id={`${fieldProperties.id}_${radio.id}`}
                  />
                  <img
                    className="unchecked"
                    alt="no seleccionado"
                    src="/assets/oferta-digital/pyme/radio_unchecked.png"
                  />
                  <img
                    className="checked"
                    alt="seleccionado"
                    src="/assets/oferta-digital/pyme/radio_checked.png"
                  />
                </div>
                <span
                  className={`item__label__span ${radio.labelClass ? radio.labelClass : ""
                    }`}
                >
                  {radio.label}
                </span>
              </label>
              {getTooltip({ tooltip: radio.tooltip, labelClass: "item" })}
            </div>
          ))}
        </RadioInputs>
        <InputWarning
          innerDivWarClass={fieldProperties.innerDivWarClass}
          innerWarningClass={fieldProperties.innerWarningClass}
          warning={warning}
        />
      </div>
    );
  };
  let getTextSelectField = (
    selectedOption,
    { handleUpdateValue, handleInput } = getInputHandlers()
  ) => {
    return (
      <div
        key={`${fieldProperties.id}_field`}
        className={fieldProperties.outerDivClass}
        id={`${fieldProperties.id}_field`}
      >
        <InputLabel label={fieldProperties.label} forId={fieldProperties.id} />
        <TextSelect
          arrowClass={fieldProperties.arrowClass}
          menuClass={fieldProperties.menuClass}
          itemClass={fieldProperties.itemClass}
          listClass={fieldProperties.listClass}
          format={fieldProperties.format}
          inputId={fieldProperties.id}
          inputClass={fieldProperties.innerFieldClass}
          containerClass={`${fieldProperties.innerDivFieldClass} 
                            ${warning != "" ? "error-field" : ""} 
                            ${!warning && value && !isActive
              ? fieldProperties.readyClass
              : ""
            } 
          ${isActive ? fieldProperties.activeClass : ""}`}
          name={fieldProperties.inputName}
          onFocus={addActiveClass}
          onBlur={(e) => {
            addActiveClass(false);
          }}
          onChange={(e) => {
            handleUpdateValue(e), addActiveClass(false);
          }}
          placeholder={fieldProperties.placeholder}
          selOption={value ? selectedOption : false}
          options={fieldProperties.selectOptions}
        />
        <InputWarning
          innerDivWarClass={fieldProperties.innerDivWarClass}
          innerWarningClass={fieldProperties.innerWarningClass}
          warning={warning}
        />
      </div>
    )
  }
  let getSelectField = (
    selectedOption,
    { handleUpdateValue, handleInput } = getInputHandlers()
  ) => {
    // console.log(selectedOption, value)
    return (
      <div
        key={`${fieldProperties.id}_field`}
        className={fieldProperties.outerDivClass}
        id={`${fieldProperties.id}_field`}
      >
        <InputLabel label={fieldProperties.label} forId={fieldProperties.id} />
        <Select
          className={`${fieldProperties.innerDivFieldClass} 
                            ${warning != "" ? "error-field" : ""} 
                            ${!warning && value && !isActive
              ? fieldProperties.readyClass
              : ""
            } 
          ${isActive ? fieldProperties.activeClass : ""}`}
          filterOption={createFilter({ ignoreAccents: false })}
          disabled={!enabled}
          classNamePrefix={"select"}
          name={fieldProperties.inputName}
          onFocus={addActiveClass}
          onBlur={(e) => {
            addActiveClass(false);
          }}
          onChange={(e) => {
            handleUpdateValue(e), addActiveClass(false);
          }}
          instanceId={fieldProperties.id}
          placeholder={fieldProperties.placeholder}
          value={value ? selectedOption : null}
          options={fieldProperties.selectOptions}
        ></Select>
        <InputWarning
          innerDivWarClass={fieldProperties.innerDivWarClass}
          innerWarningClass={fieldProperties.innerWarningClass}
          warning={warning}
        />
      </div>
    );
  };
  let getTextField = (
    { postal },
    { handleUpdateValue, handleInput } = getInputHandlers()
  ) => {
    let input = null;
    if (postal) {
      input = (
        <input
          disabled={!enabled}
          id={fieldProperties.id}
          className={fieldProperties.innerFieldClass}
          type={fieldProperties.type}
          name={fieldProperties.inputName}
          placeholder={fieldProperties.placeholder}
          onFocus={addActiveClass}
          onBlur={(e) => {
            handleInput(e);
            setTimeout(() => {
              addActiveClass(false);
            }, 400);
            return true;
          }}
          onKeyUp={handleInput}
          onChange={handleUpdateValue}
          value={value}
          maxLength={5}
        />
      );
    } else {
      input = (
        <input
          disabled={!enabled}
          id={fieldProperties.id}
          className={fieldProperties.innerFieldClass}
          type={fieldProperties.type}
          name={fieldProperties.inputName}
          placeholder={fieldProperties.placeholder}
          onFocus={addActiveClass}
          onBlur={(e) => {
            handleInput(e);
            setTimeout(() => {
              addActiveClass(false);
            }, 400);

            return true;
          }}
          onKeyUp={handleInput}
          onChange={handleUpdateValue}
          value={value}
        />
      );
    }
    return (
      <div
        key={`${fieldProperties.id}_field`}
        className={fieldProperties.outerDivClass}
        id={`${fieldProperties.id}_field`}
      >
        <InputLabel label={fieldProperties.label} forId={fieldProperties.id} />
        <div
          className={`${fieldProperties.innerDivFieldClass} 
                    ${warning != "" && !isActive ? "error-field" : ""} 
                    ${!warning && value && !isActive
              ? fieldProperties.readyClass
              : ""
            } 
                    ${isActive ? fieldProperties.activeClass : ""}`}
        >
          {input}
        </div>
        <InputWarning
          innerDivWarClass={fieldProperties.innerDivWarClass}
          innerWarningClass={fieldProperties.innerWarningClass}
          warning={warning}
        />
      </div>
    );
  };

  let InputWarning = ({
    warning,
    innerDivWarClass = "warning-container",
    innerWarningClass = "warning-content",
  }) => {
    if (!warning || isActive) return null;
    return (
      <div className={innerDivWarClass}>
        <span
          className={innerWarningClass}
          dangerouslySetInnerHTML={{ __html: `${warning}` }}
        />
      </div>
    );
  };
  let getDisplayAttr = (reqs) => {
    if (!reqs) return true;
    let display = true;
    reqs.map((req) => {
      if (form().getField(req.field).getValue() != req.value) display = false;
    });
    return display;
  };
  let getFileInput = (
    { handleInput, handleUpdateValue } = getInputHandlers()
  ) => {
    let input = (
      <input
        disabled={!enabled}
        id={fieldProperties.id}
        className={fieldProperties.innerFieldClass}
        type={fieldProperties.type}
        name={fieldProperties.inputName}
        onChange={handleUpdateValue}
      />
    );
    return (
      <div
        key={`${fieldProperties.id}_field`}
        className={`${fieldProperties.outerDivClass} `}
        style={
          getDisplayAttr(fieldProperties.reqFieldsDisplay)
            ? {}
            : { display: "none" }
        }
      >
        <div className={`progress-bar-container ${loading ? "show" : ""}`}>
          <div
            style={loading ? { width: "90%" } : {}}
            className="progress-bar"
          >Cargando documento...</div>
        </div>
        <div className={`upload_correct ${value && !loading ? "show" : ""} ${failedUpload ? "failed" : ""}`}>
          <img src={failedUpload ? "/assets/carga-documentos/inputs/faild_upload.png" : "/assets/carga-documentos/inputs/file_ready2.png"} />
          <div className="upload_text">
            {failedUpload ? "No se pudo cargar el documento" : "¡Cargado exitosamente!"}
          </div>
        </div>
        <label
          className={`${fieldProperties.innerDivFieldClass} ${loading ? 'loading_borders' : ""} 
                    ${!warning && value && !loading && !failedUpload
              ? fieldProperties.readyClass
              : ""
            } ${failedUpload ? "failed_ready_input" : ""}`}
          style={{ display: "block" }}
        >

          <div
            className={`${fieldProperties.fieldIcon ? fieldProperties.containerDivClass : ""
              }`}
          >
            <InputLabel
              label={fieldProperties.label}
              forId={fieldProperties.id}
              fileField={true}
            />
            <div>
              {input}
              <div
                className="placeholder"
                dangerouslySetInnerHTML={{
                  __html: `${fieldProperties.placeholder}`,
                }}
              />
            </div>
            {/* <InputWarning
              innerDivWarClass={fieldProperties.innerDivWarClass}
              innerWarningClass={fieldProperties.innerWarningClass}
              warning={warning}
            /> */}

          </div>
          {
            getTooltip(
              { tooltip: fieldProperties.label.tooltip, labelClass: fieldProperties.label.class },
              true
            )
          }
          <div
            style={!warning && value && !loading ? {} : { display: "none" }}
            className={`file-input-name`}
          >
            <div>
              {value ? value.name : ""}
            </div>
            {value && configModal ? (
              <div className="file-input-clear" onClick={() => {
                document.getElementById(fieldProperties.id).click();
              }}>
                Remplazar documento
              </div>
            ) : null}
          </div>
          {fieldProperties.fieldIcon && !value ? (
            <div className={fieldProperties.fieldIcon.class}>
              Cargar documento
              <div className="icon">
                {!warning && value && !loading ? (
                  <img
                    src={fieldProperties.fieldIcon.ready.src}
                    alt={fieldProperties.fieldIcon.ready.alt}
                  />
                ) : (
                  <img
                    src={fieldProperties.fieldIcon.normal.src}
                    alt={fieldProperties.fieldIcon.normal.alt}
                  />
                )}
              </div>
            </div>
          ) : null}
        </label>
      </div>
    );
  };
  let getSelectedOption = (val) => {
    // console.log(val)
    let returnVal = null;
    if (val) {
      fieldProperties.selectOptions.map((so) => {
        if (so.value == val) {
          returnVal = so;
        }
      });
    }
    return returnVal;
  };
  // useEffect(()=>{
  //     console.log("enabled change",enabled, reqFieldsState)
  // },[enabled])
  return {
    clear() {
      clearField();
    },
    getEndpointResponse() {
      return endpointResponse.current;
    },
    changeWarning(warn, print = false) {
      // if (print) console.log(warn);
      setwarning(warn);
    },
    setOptions(opts) {
      props.options = opts;
      fieldProperties.selectOptions = opts;
      forceUpdate();
    },
    updateReqFields(set) {
      reqFieldsState.current[set.name] = set.status;
      // console.log(set)
      // console.log("update req field", reqFieldsState.current)

      let enable = true;
      Object.keys(reqFieldsState.current).map((key) => {
        if (!reqFieldsState.current[key]) {
          enable = false;
        }
      });
      setEnabled(enable);
    },
    changeValue(value) {
      handleUpdateValue({
        target: {
          value: value,
        },
        nativeEvent: {
          key: "automatic",
        },
        prefilledValue: true,
      });
    },
    getWarning() {
      return warning;
    },
    getHTML() {
      let returnElement;
      let selectedOption;
      switch (props.type) {
        case `text`:
          returnElement = getTextField({
            postal: constraints.includes("postal"),
          });
          break;
        case `textSelect`:
          selectedOption = getSelectedOption(value);
          returnElement = getTextSelectField(selectedOption);
          break;
        case `select`:
          selectedOption = getSelectedOption(value);
          returnElement = getSelectField(selectedOption);
          break;
        case `radio`:
          returnElement = getRadioField();
          break;
        case `checkbox`:
          returnElement = getCheckboxField();
          break;
        case `file`:
          returnElement = getFileInput();
          break;
        default:
          returnElement = null;
          break;
      }
      return returnElement;
    },
  };
};

export default FieldComponentFactory;
